export var MicrosoftPickerErrorCode;
(function (MicrosoftPickerErrorCode) {
    MicrosoftPickerErrorCode["TIMEOUT"] = "TIMEOUT";
    MicrosoftPickerErrorCode["AUTH"] = "AUTH";
    MicrosoftPickerErrorCode["POPUP_BLOCKED"] = "POPUP_BLOCKED";
})(MicrosoftPickerErrorCode || (MicrosoftPickerErrorCode = {}));
//# sourceMappingURL=MicrosoftPickerErrorCode.js.map